export const has = (obj: any, prop: string): any => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
};

export const get = (object: any, path: string, defaultValue: any = undefined): any => {
    if (!path) throw TypeError('path should be a non-empty string');

    const keys: string[] = path.split('.');
    let curr = object;

    while (curr && keys.length) {
        const key = keys.shift();
        if (!key || !has(curr, key)) return defaultValue;
        curr = curr[key];
    }

    return curr;
};

export function listToMap(objList: any[], idProp: string): Record<string, any> {
    const mapObj: Record<string, any> = {};
    Object.entries(objList).forEach(([_, v]) => {
        mapObj[v[idProp]] = v;
    });
    return mapObj;
}
